import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Cookies from 'universal-cookie';
/**
 * Create a `universal-cookie` Cookies instance, but with the `set` and `remove`
 * methods overridden to include the passed `domain` and `path` defaults.
 */

export default function createCookieInstanceWithDefaultOptions(_ref) {
  var defaultDomain = _ref.domain,
      defaultPath = _ref.path,
      initialCookieString = _ref.initialCookieString;
  var cookiesInstance = new Cookies(initialCookieString);
  var _originalSet = cookiesInstance.set;

  cookiesInstance.set = function (name, value, options) {
    var _ref2 = options || {},
        _ref2$domain = _ref2.domain,
        domain = _ref2$domain === void 0 ? defaultDomain : _ref2$domain,
        _ref2$path = _ref2.path,
        path = _ref2$path === void 0 ? defaultPath : _ref2$path,
        restOptions = _objectWithoutProperties(_ref2, ["domain", "path"]);

    return _originalSet.call(this, name, value, _objectSpread({
      domain: domain,
      path: path
    }, restOptions));
  };

  var _originalRemove = cookiesInstance.remove;

  cookiesInstance.remove = function (name, options) {
    var _ref3 = options || {},
        _ref3$domain = _ref3.domain,
        domain = _ref3$domain === void 0 ? defaultDomain : _ref3$domain,
        _ref3$path = _ref3.path,
        path = _ref3$path === void 0 ? defaultPath : _ref3$path,
        restOptions = _objectWithoutProperties(_ref3, ["domain", "path"]);

    return _originalRemove.call(this, name, _objectSpread({
      domain: domain,
      path: path
    }, restOptions));
  };

  return cookiesInstance;
}